import { SurfCloudAPI } from "../graphql/surfApi.js";
import { downloadSurfBlobText } from "./surfBlobDownload.js";
const TERMINAL = new Set(["COMPLETED", "FAILED", "CANCELLED", "TIMED_OUT"]);
export function extractAIJobOutputText(providerUsageJson) {
    if (!providerUsageJson?.trim())
        return null;
    try {
        const root = JSON.parse(providerUsageJson);
        if (root.outputInS3 === true)
            return null;
        const raw = String(root.outputText ?? "").trim();
        return raw || null;
    }
    catch {
        return null;
    }
}
export function formatAIJobDiagnostic(job) {
    const parts = [];
    if (job.jobId)
        parts.push(`jobId=${job.jobId}`);
    if (job.status)
        parts.push(`status=${job.status}`);
    if (job.errorCode)
        parts.push(`errorCode=${job.errorCode}`);
    if (job.outputAssetKey)
        parts.push(`outputAssetKey=${job.outputAssetKey}`);
    if (job.providerUsageJson) {
        parts.push(`providerUsage=${job.providerUsageJson.slice(0, 240)}`);
    }
    if (job.errorMessage)
        parts.push(`errorMessage=${job.errorMessage}`);
    return parts.join(" · ");
}
async function resolveJobText(cfg, job) {
    const inline = extractAIJobOutputText(job.providerUsageJson);
    if (inline)
        return inline;
    const key = job.outputAssetKey?.trim();
    const presigned = cfg.presignedBaseUrl?.trim();
    if (key && presigned) {
        return downloadSurfBlobText(presigned, () => cfg.getIdToken(), key);
    }
    throw new Error("Output job AI non disponibile.", {
        cause: formatAIJobDiagnostic(job),
    });
}
export async function pollSurfAIJob(cfg, jobId, timeoutMs = 180_000) {
    const deadline = Date.now() + timeoutMs;
    while (Date.now() < deadline) {
        const job = await SurfCloudAPI.getAIJob(cfg, jobId);
        if (TERMINAL.has(job.status)) {
            if (job.status !== "COMPLETED") {
                throw new Error(job.errorMessage ?? `Job ${job.status}`, {
                    cause: formatAIJobDiagnostic({ ...job, jobId }),
                });
            }
            try {
                return await resolveJobText(cfg, { ...job, jobId });
            }
            catch (e) {
                const message = e instanceof Error ? e.message : "Output job AI non disponibile.";
                throw new Error(message, { cause: formatAIJobDiagnostic({ ...job, jobId }) });
            }
        }
        await new Promise((r) => setTimeout(r, 1500));
    }
    throw new Error("Timeout job AI.", { cause: `jobId=${jobId}` });
}
